import React, { useState } from "react";
import { Button, Dialog } from "@mui/material";
import { DialogContent, Stack, TextField, Typography } from "@mui/material";
import Repo from "../../repo/Repo";
import TailSpinLoader from "../../components/TailSpinLoader";
import Toast from "../../components/Toast";

function ForgotPassword({ open, onClose }) {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const handleInput = (e) => {
    const { value } = e.target;
    setEmail(value);
  };

  const handleForgot = async () => {
    setLoading(true);
    let { data } = await Repo.email({
      request: {
        method: "sendForgetPasswordLink",
        data: {
          to: email,
        },
      },
    });
    console.log("Data", data);
    if (data.response?.status?.statusCode === 404) {
      Toast("error", data.response?.status?.statusDescription);
    } else if (data.response?.status?.statusCode === 200) {
      // Show success toast when the email is sent successfully
      Toast("success", "Check your email to reset password.");
    }
    // Toast("success", "Check your email to reset password.");
    onClose();
  };
  const toggle = () => {
    if (!loading) {
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={toggle} fullWidth maxWidth="xs">
      <DialogContent
        sx={{
          background: "#f6f6f6",
        }}
      >
        <Stack spacing={2.4}>
          <Stack spacing={0.8}>
            <Typography
              sx={{
                fontWeight: 600,
                fontFamily: "Red Hat Display",
                fontSize: "14px",
                color: "#14224B",
              }}
            >
              Email
            </Typography>
            <TextField
              fullWidth
              size="small"
              sx={{
                background: "#fff",
                border: "none",
                borderRadius: "4px",
                "& fieldset": { border: "none" },
              }}
              placeholder="example@email.com"
              value={email}
              onChange={handleInput}
            />
          </Stack>

          {loading ? (
            <TailSpinLoader />
          ) : (
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              spacing={2}
            >
              <Button
                fullWidth
                variant="contained"
                sx={{
                  textTransform: "none",
                  background: "#ffffff !important",
                  color: "#14224B",
                  fontFamily: "Red Hat Display",
                  fontWeight: 600,
                }}
                onClick={onClose}
              >
                Cancel
              </Button>
              <Button
                fullWidth
                variant="contained"
                sx={{
                  textTransform: "none",
                  background: "#2563EB",
                  fontFamily: "Red Hat Display",
                  fontWeight: 600,
                  "&:hover": {
                    background: "#1D4ED8",
                  },
                }}
                onClick={handleForgot}
              >
                Submit
              </Button>
            </Stack>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default ForgotPassword;
